/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import InputDate from '../../../components/inputs/InputDate';

import TabelWorker from '../../../components/tabel/tabelWorker/TabelWorker';
import InputNumber from '../../../components/inputs/InputNumber';
import DashboardContext from '../../../Context';
import FormOrder from '../../Order/Order/FormOrder';
import InputControl from '../../../components/inputs/InputControl';
import InputControlMulti from 'components/inputs/InputControlMulti';

export default function OrderCustomer() {
  const {
    handelFromTabel,
    sideBardata,
    showEditOrder,
    handelEditOrder,
    handeldmicro,
    showformmicro,
    setOnSearchLoading,
    searchLoading,
  } = useContext(DashboardContext);

  const [arryactions, setArryactions] = useState([]);

  const [isShowForm, setIsShowForm] = useState(false);

  const [dataFrom, setDataFrom] = useState({
    userId: JSON.parse(sessionStorage.getItem('customerid')),
  });

  useEffect(() => {
    handelFromTabel({
      userId: JSON.parse(sessionStorage.getItem('customerid')),
    });

    if (sideBardata) {
      sideBardata.map((item) => {
        item.controllers.filter((find) => {
          if (`/${find.controller}` === '/Order') {
            setArryactions(find.actions);
            return find;
          }
        });
      });
    }
    return () => {};
  }, []);

  const handelValue = (name, value) => {
    switch (name) {
      case 'fromStartWork':
        setDataFrom({ ...dataFrom, fromStartWork: value });
        break;
      case 'toStartWork':
        setDataFrom({ ...dataFrom, toStartWork: value });
        break;
      case 'trackingCode':
        setDataFrom({ ...dataFrom, trackingCode: parseInt(value) });
        break;
      case 'addressIds':
        setDataFrom({ ...dataFrom, addressIds: value });
        break;
      case 'searchCustomerOrderFilterType':
        setDataFrom({ ...dataFrom, searchCustomerOrderFilterType: value });
        break;
      default:
        break;
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();
    setOnSearchLoading();
    handelFromTabel(dataFrom);
  };

  const handelclene = () => {
    handelFromTabel({
      userId: JSON.parse(sessionStorage.getItem('customerid')),
    });
    setDataFrom({ userId: JSON.parse(sessionStorage.getItem('customerid')) });
  };

  useEffect(() => {
    handelclene();
  }, [showEditOrder, showformmicro]);

  return (
    <>
      {showEditOrder ? (
        <>
          <Button
            variant='danger'
            className='mb-3'
            onClick={() => {
              handelEditOrder(false);
              handelclene();
            }}
          >
            لغو
          </Button>
          <FormOrder
            userprofile={JSON.parse(sessionStorage.getItem('customerid'))}
          />
        </>
      ) : showformmicro ? (
        <>
          <Button
            variant='danger'
            className='mb-3'
            onClick={() => {
              handeldmicro(false);
              handelclene();
            }}
          >
            لغو
          </Button>
          <FormOrder
            userprofile={JSON.parse(sessionStorage.getItem('customerid'))}
          />
        </>
      ) : (
        <>
          <Button
            variant='primary'
            className='mb-3'
            onClick={() => handeldmicro(true)}
          >
            افزودن سفارش
          </Button>
          {isShowForm ? (
            <Form>
              <Form.Row>
                <Col lg='3' md='3' sm='12' xs='12'>
                  <InputDate
                    label='تاریخ شروع از'
                    name='fromStartWork'
                    handelValue={handelValue}
                  />
                </Col>
                <Col lg='3' md='3' sm='12' xs='12'>
                  <InputDate
                    label='تاریخ شروع تا'
                    name='toStartWork'
                    handelValue={handelValue}
                  />
                </Col>
                <Col lg='3' md='3' sm='12' xs='12'>
                  <InputNumber
                    label='کد پیگیری'
                    name='trackingCode'
                    handelValue={handelValue}
                  />
                </Col>
                <Col lg='3' md='3' sm='12' xs='12'>
                  <InputControlMulti
                    url={`/userManagement/addressDropdown/${JSON.parse(
                      sessionStorage.getItem('customerid'),
                    )}`}
                    label='آدرس های مشتری'
                    name='addressIds'
                    handelValue={handelValue}
                  />
                </Col>
                <Col>
                  <InputControl
                    url='/common/SearchCustomerFilterTypeDropdown'
                    label='فیلتر'
                    name='searchCustomerOrderFilterType'
                    handelValue={handelValue}
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col className='d-flex'>
                  <Button onClick={handelSubmit} variant='success'>
                    {searchLoading ? (
                      <i className='fa fa-spinner fa-pulse fa-fw'></i>
                    ) : (
                      '   جستجو'
                    )}
                  </Button>
                </Col>
              </Form.Row>
            </Form>
          ) : null}

          <Row>
            <Col className='mt-5 mb-3'>
              <Button
                onClick={() => {
                  setIsShowForm(!isShowForm);
                  handelclene();
                }}
                variant={isShowForm ? 'danger' : 'primary'}
              >
                {isShowForm ? 'پاک کردن و بستن جستجو' : 'جستجو پیشرفته'}
              </Button>
            </Col>
          </Row>
          {arryactions.includes('Get') ? (
            <TabelWorker
              urldata='/Order'
              isFromProfile={true}
              arryactions={arryactions}
            />
          ) : null}
        </>
      )}
    </>
  );
}
